import { queryOptions, skipToken } from '@tanstack/react-query';
import { QueryKey } from 'core/react-query/queryClient';
import { getBoxMembers } from 'networking/mindfeed/services/box.service';
import type { BoxId } from 'models/Box';

// The members of a box. No box id: defined, never runs.
export const boxMembersQuery = (boxId?: BoxId) =>
  queryOptions({
    queryKey: [QueryKey.BOX_MEMBERS, boxId],
    queryFn: boxId ? () => getBoxMembers(boxId) : skipToken,
    staleTime: 5000,
    retry: 1,
  });
